import {
  DropdownField as DSDropdownField,
  DropdownFieldProps as DSDropdownFieldProps,
  Omit,
} from "@dbn/omnichannel-design-system-g4p";
import { useFormatMessage } from "../../intl";

export type DropdownFieldProps<T> = Omit<
  DSDropdownFieldProps<T, false>,
  | "cancelLabel"
  | "noResultsLabel"
  | "clearSelectionLabel"
  | "filterInputPlaceholder"
  | "ctaLabel"
  | "mobileDrawerCloseButtonAriaLabel"
> & {
  forceDrawerOnMobile?: boolean;
};

export function DropdownField<T>(props: DropdownFieldProps<T>) {
  const formatMessage = useFormatMessage();
  return (
    <DSDropdownField
      {...props}
      cancelLabel={formatMessage("Cancel")}
      noResultsLabel={formatMessage("Dropdown.NoResultsFound")}
      clearSelectionLabel={formatMessage("Dropdown.clearSelection")}
      filterInputPlaceholder={formatMessage("Dropdown.filterInputPlaceholder")}
      ctaLabel={formatMessage("Confirm.buttonLabel")}
      isMulti={false}
      mobileDrawerOkText={formatMessage("Dropdown.ok")}
      mobileDrawerCloseButtonAriaLabel={formatMessage("Dropdown.closeButton")}
      forceDrawerOnMobile={props.forceDrawerOnMobile}
    />
  );
}
